export default __webpack_public_path__ + "static/media/resourcesHero.00158800.jpg";